import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavbarService } from "../../services/navbar.service";
import { Subscription } from "rxjs";
import { StorageService } from "../../services/storage.service";

@Component({
    selector: "app-portal",
    templateUrl: "./portal.component.html",
    styleUrls: ["./portal.component.scss"],
})
export class PortalComponent implements OnInit, OnDestroy {
    isNavOpen: boolean = false;
    isLoggedIn: boolean = false;
    subscriptions: Subscription[] = [];

    constructor(
        private storageService: StorageService,
        private navBarService: NavbarService
    ) {}

    ngOnInit() {
        this.isLoggedIn = this.storageService.getItem("token") != undefined;

        this.subscriptions.push(
            this.navBarService.toggleSubject.subscribe((result) => {
                if (result != undefined) {
                    this.isNavOpen = result;
                } else {
                    this.isNavOpen = !this.isNavOpen;
                }
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) =>
            subscription.unsubscribe()
        );
    }
}
